import { createContext } from 'react'
import type { TimeFormatPref } from '@shared/preferences'
import type { HourCycle } from '../lib/timeFormat'

export interface TimeFormatContextValue {
  pref: TimeFormatPref
  hourCycle: HourCycle
  /** What `auto` resolves to right now, for labelling the option. */
  autoHourCycle: HourCycle
  locale: string
  setPref: (pref: TimeFormatPref) => void
  /** Display an "HH:mm" set time in the user's clock format. */
  formatClock: (hhmm: string) => string
  /** "start – end"; in 12h only the end carries AM/PM. */
  formatClockRange: (start: string, end: string) => string
}

export const TimeFormatContext = createContext<TimeFormatContextValue>({
  pref: 'auto',
  hourCycle: '24h',
  autoHourCycle: '24h',
  locale: 'en_US',
  setPref: () => {},
  formatClock: hhmm => hhmm,
  formatClockRange: (start, end) => `${start} – ${end}`,
})
